import { IconProps } from "./IconProps";

const CheckCircleIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = "#2EDADC",
  color2 = "#FCFCFD",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none">
      <circle cx="12" cy="12.3521" r="10" fill={color} />
      <path
        d="M8 12.3521L11 15.3521L17 9.35205"
        stroke={color2}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default CheckCircleIcon;
